import { useDefaultUploadGate } from '#pplx/frontend/apps/ask/hooks/file-attachments-hooks/useDefaultUploadGate.js';
import { useOrganizationAttachmentPreferences } from '#pplx/frontend/apps/ask/organization/hooks/useOrganizationAttachmentPreferences.js';
import { useCallback, useMemo, useRef } from 'react';
/** @returns Cloud picker policy, omitted when uploads are unavailable. */
export function useAskComposerCloudMenuProps({ attachments, showFileUpload, disabled, isFollowUp, }) {
    const gateUploadFile = useDefaultUploadGate({
        checkUploadFile: attachments.uploadGate.checkUploadFile,
        isFollowUp,
    });
    const { disabledByOrganization } = useOrganizationAttachmentPreferences({
        reason: attachments.reason,
    });
    const cloudUploadsEnabled = showFileUpload && disabled !== true && !disabledByOrganization;
    const cloudSelectionRef = useRef({
        enabled: cloudUploadsEnabled,
        upload: attachments.uploadCloudFiles,
    });
    cloudSelectionRef.current = {
        enabled: cloudUploadsEnabled,
        upload: attachments.uploadCloudFiles,
    };
    const onCloudFilesSelected = useCallback((files, provider) => {
        if (!cloudSelectionRef.current.enabled || files === undefined)
            return;
        switch (provider) {
            case 'google_drive':
            case 'onedrive':
            case 'sharepoint':
            case 'dropbox':
            case 'box':
                cloudSelectionRef.current.upload(files.flatMap((file) => file instanceof File
                    ? []
                    : [
                        {
                            provider,
                            id: file.id,
                            name: file.name ?? '',
                            mimeType: file.mimeType,
                            sizeBytes: file.sizeBytes,
                        },
                    ]));
                break;
            case 'local':
            case undefined:
                break;
        }
    }, []);
    return useMemo(() => cloudUploadsEnabled
        ? {
            onFilesSelected: onCloudFilesSelected,
            canUploadFile: attachments.uploadGate.canUploadFile,
            gateUploadFile,
            disabledByOrganization,
        }
        : undefined, [
        cloudUploadsEnabled,
        onCloudFilesSelected,
        attachments.uploadGate.canUploadFile,
        gateUploadFile,
        disabledByOrganization,
    ]);
}
//# sourceMappingURL=useAskComposerCloudMenuProps.js.map